import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { formatUtm, toUtm22S } from "@/lib/utm";

/** Escala grafica e coordenada do ponteiro (graus WGS84 e UTM SIRGAS 2000 / 22S). */
export default function MapScaleAndPointer() {
  const map = useMap();
  const [pos, setPos] = useState<{ lat: number; lng: number } | null>(null);
  const [zoom, setZoom] = useState(() => map.getZoom());

  useEffect(() => {
    const scale = L.control.scale({ imperial: false, position: "bottomleft", maxWidth: 140 }).addTo(map);
    const onMove = (e: L.LeafletMouseEvent) => setPos(e.latlng);
    const onOut = () => setPos(null);
    const onZoom = () => setZoom(map.getZoom());
    map.on("mousemove", onMove);
    map.on("mouseout", onOut);
    map.on("zoomend", onZoom);
    return () => {
      scale.remove();
      map.off("mousemove", onMove);
      map.off("mouseout", onOut);
      map.off("zoomend", onZoom);
    };
  }, [map]);

  const utm = pos ? toUtm22S(pos.lat, pos.lng) : null;
  return (
    <div className="absolute left-2 bottom-9 z-[1000] pointer-events-none bg-white/90 border border-background-200 rounded-md px-2 py-1 text-[10px] font-mono text-foreground-700 shadow-sm">
      {pos && utm ? (
        <>
          <div>{pos.lat.toFixed(6)}, {pos.lng.toFixed(6)}</div>
          <div>UTM 22S E {formatUtm(utm.e)} N {formatUtm(utm.n)}</div>
        </>
      ) : (
        <div className="font-sans">Passe o ponteiro sobre o mapa</div>
      )}
      <div className="font-sans text-foreground-400">Zoom {zoom}</div>
    </div>
  );
}
